var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"open-fund-header row justify-between"},[_c('combined-logo'),(_vm.showShoppingCart)?_c('shopping-cart-icon',{attrs:{"indicator":_vm.indicator,"blink":_vm.blink},on:{"click":_vm.shoppingCartClicked}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }